import React from 'react';
// import sourceBannerWeb from '../../assets/home/BannerWeb.svg';
// import sourceBannerMobile from '../../assets/home/BannerMobile.svg';
import './styles.scss';

const BannerHome = () => {
  // return (
  //   <div className='bannerHome'>
  //     <img
  //       src={sourceBannerWeb}
  //       alt='Banner pode morar'
  //       className='bannerWeb'
  //     />
  //     <img
  //       src={sourceBannerMobile}
  //       alt='Banner pode morar'
  //       className='bannerMobile'
  //     />
  //   </div>
  // );
  return <></>;
};

export default BannerHome;
